import { Stack } from "@mantine/core";
import { usePartnerConfig } from "@/partner/usePartnerConfig";
import type { TechSupportMetrics } from "../api/types";
import { usePerformanceMetrics, useTotalCallCount } from "../hooks/useMetric";
import { formatEDPSourcedUpdatedTime } from "../utils/getFormattedDate";
import { MetricCard } from "./MetricCard";

export function PerformanceMetrics() {
    const { data: metrics, isLoading: isLoadingMetrics, isError: isMetricsError } = usePerformanceMetrics();
    const { data: numCalls, isLoading: isLoadingCalls, isError: isCallsError } = useTotalCallCount();
    const metricsConfig = usePartnerConfig().performanceMetrics;

    return (
        <Stack>
            <MetricCard
                isError={isCallsError}
                isLoading={isLoadingCalls}
                header={`${numCalls} calls`}
                body="Total calls"
                updatedTime="Live"
            />
            {metricsConfig.map((conf) => {
                const lastUpdatedKey: `${keyof TechSupportMetrics}LastUpdated` = `${conf.metric}LastUpdated`;
                const updatedTime = formatEDPSourcedUpdatedTime(metrics?.[lastUpdatedKey]);

                return (
                    <MetricCard
                        key={conf.metric}
                        isError={isMetricsError}
                        isLoading={isLoadingMetrics}
                        header={`${metrics?.[conf.metric]}${conf.header}`}
                        body={conf.body}
                        updatedTime={updatedTime}
                    />
                );
            })}
        </Stack>
    );
}
